export const Details = 0
export const Email = 1
export const Phone = 2
export const Chat = 3
export const WhatsApp = 4
